// Module
var code = "<driver-form model=\"item\" our-firms=\"ourFirms\" on-close=\"$close(model)\">\n</driver-form>\n";
// Exports
module.exports = code;